import { Stack, Group, Text, Badge } from '@repletoryreach/sdk-ui';
import type { admin } from '@repletoryreach/sdk-api';
import { useT } from '../../../../i18n/I18nProvider';

interface Props {
  issues: admin.AdminInvoiceValidateResult['validation']['issues'];
  validator: admin.AdminInvoiceValidateResult['validation']['validator'];
}

/**
 * What the tax validator objected to, one row per issue. The same shape comes
 * back from the 422 body of a strict validation, so one renderer covers both.
 */
export function ValidationIssues({ issues, validator }: Props) {
  const t = useT();
  if (issues.length === 0) {
    return <Text role="bodySmall">{t('billing.invoices.modal.validate.none')}</Text>;
  }
  return (
    <Stack gap="md">
      {validator && (
        <Text role="bodySmall" c="var(--rr-color-text-muted)">
          {t('billing.invoices.modal.validate.validator', { validator: validator.toUpperCase() })}
        </Text>
      )}
      <Stack gap="sm">
        {issues.map((issue) => (
          <Stack key={`${issue.code}:${issue.field}`} gap="xs">
            <Group gap="xs" align="center" wrap="nowrap">
              <Badge size="xs" variant="light" color={issue.severity === 'error' ? 'red' : 'orange'}>
                {issue.severity === 'error'
                  ? t('billing.invoices.modal.validate.severityError')
                  : t('billing.invoices.modal.validate.severityWarning')}
              </Badge>
              <Text role="bodySmall" fw={600}><code>{issue.code}</code></Text>
              <Text role="caption" c="var(--rr-color-text-muted)">{issue.field}</Text>
            </Group>
            <Text role="bodySmall">{issue.message}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
